import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import type {
	preloadCreateSpaceQuery$data,
	preloadCreateSpaceQuery$variables,
} from '@confluence/create-space-preload/entry-points/preloadCreateSpace.ts';
import { PreloadCreateSpaceQuery } from '@confluence/create-space-preload/entry-points/preloadCreateSpace.ts';

type Operations =
	| {
			readonly operation: string | null | undefined;
	  }
	| null
	| undefined;

export const useCanCreateSpace = () => {
	const { isLicensed } = useSessionData();

	const { data: canCreateData, loading } = useQueryInterop<
		preloadCreateSpaceQuery$data,
		preloadCreateSpaceQuery$variables
	>(
		// Due to circular dependency issues we are using the PreloadCreateSpaceQuery from create-space-preload package
		PreloadCreateSpaceQuery,
		{
			skip: !isLicensed,
		},
	);

	const canCreateSpace = Boolean(
		canCreateData?.user?.confluence?.operations.some(
			(obj: Operations) => obj?.operation === 'create_space',
		),
	);

	return { canCreateSpace, loading };
};
